"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGridHelper = void 0;
const three_1 = require("three");
function createGridHelper(webgl, size, division, color1, color2) {
    const gridHelper = new three_1.GridHelper(size, division, color1, color2);
    gridHelper.visible = false;
    webgl.addObject(gridHelper);
    return gridHelper;
}
exports.createGridHelper = createGridHelper;
